import { computed, ref } from 'vue'

import { useDocumentStore } from '@/store/document'

const blockElementMap = ref<{ [key: string]: any }>({})
const isAllBlockElementsLoaded = ref(false)

export function useBlockElements() {
  const store = useDocumentStore()
  const blockElements = computed(() => store.flatBlockElements)
  const setIsAllBlockElementsLoaded = (value: boolean) => {
    isAllBlockElementsLoaded.value = value
  }

  const addBlockElement = (id: string, type: string) => {
    blockElementMap.value[id] = {
      id,
      type,
    }

    if (
      Object.keys(blockElementMap.value).length ===
        blockElements.value.length &&
      !isAllBlockElementsLoaded.value
    ) {
      setIsAllBlockElementsLoaded(true)
    }
  }

  const getBlockElement = (id: string) => {
    return blockElementMap.value[id]
  }

  return {
    isAllBlockElementsLoaded,
    setIsAllBlockElementsLoaded,
    addBlockElement,
    getBlockElement,
  }
}
